{
  "resources": "WATCH_COUNT",
  "filters": [
    {
      "key": "{{:resourceType:}}",
      "value": "{{:id:}}",
      "op": "=="
    }
  ],
  "dateRange": {
    "start": "{{:startDateTime:}}",
    "end": "{{:endDateTime:}}"
  }
}